import moment from "moment";
import trans from "../../services/Translator";
/**
 * Accepts booleans as well as their string representations.
 */
export function toBoolean(value) {
    if (value === undefined || value === null || value === '') {
        return undefined;
    }
    if (value === 'true') {
        return true;
    }
    if (value === 'false') {
        return false;
    }
    return !!value;
}
export function toTriState(value) {
    const bool = toBoolean(value);
    return bool === undefined ? '' : (bool ? 'true' : 'false');
}
export function fromTriState(value) {
    return value === '' ? undefined : value === 'true';
}
export function toText(value) {
    if (value === undefined || value === null) {
        return undefined;
    }
    return typeof value === 'string' ? value : '' + value;
}
export function toNumber(value) {
    if (value === undefined || value === null) {
        return undefined;
    }
    return typeof value === 'number' ? value : parseFloat('' + value);
}
/**
 * The browser reports an empty or unparsable number input as `''`.
 */
export function fromNumberInput(value) {
    return (value === undefined || value === '' || isNaN(value)) ? null : value;
}
export function toDateInput(value) {
    return value ? moment(value).format('YYYY-MM-DD') : null;
}
export function fromDateInput(value) {
    return value ? moment(value).format('YYYY-MM-DD') : null;
}
/**
 * Converts a zoned date time to the local date time of a `datetime-local` input.
 */
export function toDatetimeInput(value) {
    return value ? moment(value).format('YYYY-MM-DDTHH:mm:ss') : null;
}
/**
 * Adds the time zone offset unless the field holds a local date time.
 */
export function fromDatetimeInput(value, local) {
    return value ? moment(value).format('YYYY-MM-DDTHH:mm:ss' + (local ? '' : 'ZZ')) : null;
}
/**
 * The label of a choice. Choices without a label are translated with the same
 * key as in the former Angular astina-form (choiceLabel in ui-base), falling
 * back to the raw value.
 */
export function choiceLabel(form, field, choice) {
    if (choice.label) {
        return choice.label;
    }
    const key = form.name + '_' + field.name + '_' + choice.value.replace(/[\t\n .()/]/g, '_');
    return trans(key, undefined, choice.value);
}
const TIME_PATTERN = /^(?:[0-1][0-9]|2[0-4]):[0-5][0-9](?::[0-5][0-9])?$/;
/**
 * Both ends are optional, but must be valid times, and `from` must not be after `to`.
 */
export function isValidTimeRange(range) {
    if (range.from && !TIME_PATTERN.test(range.from)) {
        return false;
    }
    if (range.to && !TIME_PATTERN.test(range.to)) {
        return false;
    }
    if (range.from && range.to) {
        return parseInt(range.from.replace(':', '')) <= parseInt(range.to.replace(':', ''));
    }
    return true;
}
